import { render, staticRenderFns } from "./Artigos.vue?vue&type=template&id=7a485c3c&scoped=true&"
import script from "./Artigos.vue?vue&type=script&lang=js&"
export * from "./Artigos.vue?vue&type=script&lang=js&"
import style0 from "./Artigos.vue?vue&type=style&index=0&id=7a485c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a485c3c",
  null
  
)

export default component.exports